/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const CheckFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Check Filled 24">
      <circle cx={12} cy={12} r={10} fill="#94B200" className="Fill-Main" />
      <path
        className="Details"
        fill="#fff"
        fillRule="evenodd"
        d="M17.783 8.216a.712.712 0 0 1-.006 1.028l-6.825 6.546a.767.767 0 0 1-1.054 0l-3.675-3.525a.712.712 0 0 1-.006-1.028.767.767 0 0 1 1.06-.006l3.148 3.019 6.298-6.04a.767.767 0 0 1 1.06.006Z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const CheckFilledIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'check-filled-icon'}
      icon={CheckFilled}
      {...props}
      size={size}
    />
  );
};
